var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center submission-container p-2"},[_c('div',{staticClass:"btn btn-sm btn-dark m-1",class:_vm.isQueryDirty ? 'is-dirty':'',on:{"click":_vm.submitSearch}},[_vm._v("SUBMIT")]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-dark m-1",on:{"click":_vm.resetQuery}},[_vm._v("RESET")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6876c4ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalAlleyStarts/SearchSubmission.vue
// module id = null
// module chunks = 